import { useInternalState, assignMswData, serializeQuery } from '../hooks/internalState';
import {
  PostGuestUsersResult,
  PostGuestUsersOptions,
  PostGuestUsersFields,
  postGuestUsers,
} from '../fetchers/guest_users';
import { useCallback } from 'react';
import { useSWRConfig } from 'swr';
import { useGctlConfig } from '../hooks/GctlProvider';

/**
 * DO NOT MODIFY
 * Auto-generated by gctl-plugin-vimeo-hooks
 */

type UsePostGuestUsersOptions<Fields extends PostGuestUsersFields> = PostGuestUsersOptions<Fields>;

/**
 * Create a guest user
 * This method creates a guest user.
 */

export function usePostGuestUsers<Fields extends PostGuestUsersFields>() {
  const { mutate } = useSWRConfig();
  let { baseUrl, jwt, xVimeoPage, locale } = useGctlConfig();

  let [state, dispatch] = useInternalState<PostGuestUsersResult<Fields> | undefined>();

  let call = useCallback(
    async (options: UsePostGuestUsersOptions<Fields>) => {
      dispatch({ type: 'REQUEST' });

      try {
        let result = await mutate(
          `/guest_users${serializeQuery(options)}`,
          postGuestUsers({
            ...options,
            baseUrl,
            headers: {
              ...options.headers,
              'Content-Type': 'application/json',
              Authorization: jwt ? `jwt ${jwt}` : '',
              'Vimeo-Page': `${xVimeoPage}`,
              'Accept-Language': locale ?? 'en',
            },
          }),
          false,
        );

        dispatch({ type: 'SUCCESS', payload: result });
      } catch (err) {
        dispatch({ type: 'FAILURE', payload: err });
      }
    },
    [baseUrl, xVimeoPage, jwt, locale, dispatch],
  );

  return [call, state] as const;
}

if (process.env.NODE_ENV !== 'production' || process.env.STORYBOOK === 'true') {
  assignMswData(usePostGuestUsers, {
    endpoint: '/guest_users',
    method: 'POST',
  });
}
